import styled, { StyledFunction } from "styled-components"

export const TableHeaderWrapper = styled.table`
    & > thead > tr > th {
        color: white;
        overflow: hidden;
        padding: 5px 0px 5px 3px !important;
    }
`;

export const TableRowWrapper = styled.tr`
    & > td {
        padding: 3px 0px 3px 3px !important;
        vertical-align: middle !important;
    }
`;

export const SummaryTitles = styled.tr`
    & > td {
        background-color: #00004c;
        color: white;
        font-size: 9px;
    }
`;

export const SummaryValues = styled.tr`
    & > td {
        font-size: 12px;
    }
`;

interface IGridWrapperProps {
    height?: string
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: ${p => p.height ? p.height : '82vh'};
    
    font-family: Roboto;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
    }

    .customHeaderLabel {
        text-align: center;
    }
`;

export const HeaderWrapper = styled.div`
    .billing-header {
        font-size: 28px;
        font-weight: 500;
    }
`;